import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class Mothers2022 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,
		};
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			console.log(this.props);
			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

	render() {
		return <div className='Mothers2022'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/mother_lander.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/mother_lander_m.jpg" alt="Diamonds Direct" />
			</div>
			<div className='copySection'>
				<div className='copyTitle'>Save 20% on Mother’s Day gifts through May 7th*</div>
				<div className='copyCopy'>Mother’s Day is the perfect time to build your time capsule jewelry collection to pass down for generations to come. Now through May 7th, shop classic diamond jewelry that will shine forever!</div>
			</div>
			<div className='blockSection'>
				<div className='blockSectionWrapper'>
					<div className={'blockItem fianceBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/studs.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock rightCopy'}>
								<div className='mrBlockWrapper'>
									<div className='mrbButton' onClick={() => this.internalNav('diamond-studs')}><div>Shop Diamond Studs</div></div>
								</div>
							</div>
						</div>
					</div>
					<div className={'blockItem newlywedBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock mobileMakeup'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/pendants.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock'}>
								<div className='mrBlockWrapper'>
									<div className='mrbButton' onClick={() => this.internalNav('diamond-pendants')}><div>Shop Diamond Pendants</div></div>
								</div>
							</div>
							<div className={'mrBlock imgBlock rightImg'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/pendants.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
						</div>
					</div>
					<div className={'blockItem gradBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2022/lander/bracelets.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock rightCopy'}>
								<div className='mrBlockWrapper'>
									<div className='mrbButton' onClick={() => this.internalNav('diamond-bracelets')}><div>Shop Diamond Bracelets</div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='formBoxWrapper'>
				<div className='formInnerWrapper'>
					
					<div className='formP'>Walk-in visits are always welcome! But if you’d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>

					<div className='formWrapper'>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorName ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Full Name*'
								value={this.state.inputName}
              					onChange={::this.changeName} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorEmail ? 'textInput error' : 'textInput'}
								type='email' 
								placeholder='Email Address*'
								value={this.state.inputEmail}
              					onChange={::this.changeEmail} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorPhone ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Telephone'
								value={this.state.inputPhone}
              					onChange={::this.changePhone} />
						</div>
						<div className='formInputWrapper'>
							<RhinoSelect
				                selectClass={'summerSelect'}
				                required={true}
				                value={this.state.inputLocation}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeLocation(evt)}
				                error={this.state.errorLocation !== null} />
						</div>
						<div className='formActionRow'>
							<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
						</div>
					</div>
				</div>
			</div>
			<div className='legalSection'>*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers.</div>
		</div>;
	}
}
export default Mothers2022;

function mapStateToProps(state) {
  return {

  };
}

export const Mothers2022Container = connect(
  mapStateToProps,
  allActionCreators
)(Mothers2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/mothers2022/Mothers2022.jsx